export default {
  summary: {
    delivery: 'Dostawa: karta podarunkowa jako PDF e-mailem',
  },
};
